import React from 'react';

import { useTheme } from '@mui/material/styles';

import { ArrowBackIosNewIcon } from '@/assets/icon/ArrowBackIosNewIcon';
import PlainIconButton from '@/components/atoms/PlainIconButton/PlainIconButton';
import SearchInput from '@/components/atoms/SearchInput/SearchInput';
import type { SearchInputRef } from '@/types/search.types';

import {
  BackButtonSx,
  IconButtonPlainStyle,
  SearchbarWrapper,
} from './SearchStart.styles';

type NativeSearchBarProps = {
  trimmedValue: string;
  placeholder: string;
  searchInputRef?: React.RefObject<SearchInputRef | null>;
  recommendation?: string | string[] | undefined;
  readOnly?: boolean;
  enabledOnClickBack?: boolean;
  onBack: (isFromBackButton?: boolean) => void;
  onChange: (value: string) => void;
  onEnter?: (value: string) => void;
  showClearIcon?: boolean;
  onClear?: () => void;
};

const NativeSearchBar: React.FC<NativeSearchBarProps> = ({
  trimmedValue,
  placeholder,
  searchInputRef,
  recommendation,
  readOnly = false,
  enabledOnClickBack = false,
  showClearIcon,
  onBack,
  onChange,
  onEnter,
  onClear,
}) => {
  const theme = useTheme();

  const onBackHandle = (
    e: React.MouseEvent | React.TouchEvent,
    value: boolean
  ) => {
    e.preventDefault(); // Cancels the pending click event (no double-fire)
    e.stopPropagation();
    onBack(value);
  };

  return (
    <SearchbarWrapper isNative={true}>
      <PlainIconButton
        onTouchStart={(e) => {
          console.log('before navigation', performance.now());
          onBackHandle(e, true);
        }}
        aria-label="Back"
        style={IconButtonPlainStyle}
      >
        <ArrowBackIosNewIcon fontSize="small" style={BackButtonSx(theme)} />
      </PlainIconButton>
      {!recommendation && (
        <SearchInput
          ref={searchInputRef}
          value={trimmedValue}
          placeholder={placeholder}
          isNative={true}
          isSearchbarWhite={true}
          readOnly={readOnly}
          onChange={onChange}
          onEnter={onEnter}
          showClearIcon={showClearIcon}
          onClick={() => enabledOnClickBack && onBack(false)}
          onClear={onClear}
        />
      )}
    </SearchbarWrapper>
  );
};

export default NativeSearchBar;
